import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { ITimeoutService } from 'angular';

export class DashboardService {
  static $inject = [
    '$timeout'
  ];

  private _showSbMenu = new Subject<boolean>();

  constructor( private $timeout: ITimeoutService ) {
  }

  onShowSbMenu(): Observable<boolean> {
    return this._showSbMenu.asObservable();
  }

  toggleSbMenu( isShow: boolean ) {
    this.$timeout(() => {
      this._showSbMenu.next(isShow);
    });
  }
}



// WEBPACK FOOTER //
// ./app/states_mobile/dashboard/dashboard.service.ts